import { render, staticRenderFns } from "./SurveySplashItem.vue?vue&type=template&id=e62a2766&scoped=true&"
import script from "./SurveySplashItem.vue?vue&type=script&lang=js&"
export * from "./SurveySplashItem.vue?vue&type=script&lang=js&"
import style0 from "./SurveySplashItem.vue?vue&type=style&index=0&id=e62a2766&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e62a2766",
  null
  
)

export default component.exports